<template>
  <div v-if="payment" class="payments-box">
    <p>
      <span class="label">Odpłatność:</span>
      <span class="value">{{ payment.amount }} zł</span>
    </p>
    <p>
      <span class="label">Obowiązuje od:</span>
      <span class="value">{{ formatDate(payment.dateFrom) }}</span>
    </p>
    <p>
      <span class="label">Obowiązuje do:</span>
      <span class="value">{{
        payment.dateTo ? formatDate(payment.dateTo) : "--.--.----"
      }}</span>
    </p>
  </div>
</template>

<script>
import shared from "../../shared";
export default {
  name: "CustomerPaymentItem",
  props: ["payment"],
  methods: {
    formatDate(date) {
      return shared.dateToDayMonthYearFormatUTCOffset0(date);
    },
  },
};
</script>

<style scoped>
.payments-box {
  margin: 0;
  padding: 0;
}
p {
  color: #000;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.label {
  font-weight: 600;
  margin-right: 0.5rem;
}
</style>